import { useRegisterSW } from 'virtual:pwa-register/react';
import './install-hint.css';

/**
 * Плашка «Есть новая версия».
 *
 * Обновление предлагается, а не применяется молча: юрист может писать заметку по делу
 * или заполнять карточку, и перезагрузка страницы под руками унесла бы набранное.
 * Пока он не нажал, работает прежняя версия — она в кэше и полностью рабочая.
 */
export function UpdateBanner() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="update-banner" role="status">
      <span className="update-banner__text">Есть новая версия</span>
      <button
        type="button"
        className="update-banner__action"
        onClick={() => {
          setNeedRefresh(false);
          void updateServiceWorker(true);
        }}
      >
        Обновить
      </button>
    </div>
  );
}
